import { combineReducers, } from "@reduxjs/toolkit";
import marketData from "./mainBoard/marketUXSlice";

const uxTradingReducer = combineReducers({
  marketData,
});

export default uxTradingReducer